import * as React from 'react';

import Page from 'components/page/Page';
import AccessContainer from '../../components/access-container/AccessContainer';

import AppStore from '../../components/app-store/AppStore';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./app-store-page.i18n.json'));

const MSG_KEY = 'app_store_page';

const AppStorePage = (): JSX.Element => (
  <Page
    documentTitle={__t(`${MSG_KEY}.title`)}
  >
    <AccessContainer type="app-store">
      <AppStore />
    </AccessContainer>
  </Page>
);

export default AppStorePage;
